/**
 * データ型を返す
 *
 * @param {*} x
 * @returns {String} データ型を返す
 */
export function gettype (x) {
  if (x === null) {
    return 'null'
  }

  const type = typeof x
  if (type !== 'object') {
    return type
  }
  if (Array.isArray(x)) {
    return 'array'
  }
  if (x instanceof Date) {
    return 'date'
  }
  if (x instanceof RegExp) {
    return 'regexp'
  }
  return 'object'
}
